import { create } from "zustand";


interface ProposalSelectionPendingStoreProps {
    isSelectionPending: boolean;
    setIsSelectionPending: (payload: boolean) => void;
}

export const proposalSelectionPendingStore = create<ProposalSelectionPendingStoreProps>((set) => ({
    isSelectionPending: false,
    setIsSelectionPending: (payload) => set(() => ({
        isSelectionPending: payload,
    })),
}));
